import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoSingleSelectDropdownInput } from "@redotech/arbiter/select-dropdown/redo-single-select-dropdown-input";
import { DiscountValueType } from "@redotech/redo-discounts-common/discount";
import { discountValueTypeItems } from "../constants";

export function DiscountAmountField({
  amount,
  setAmount,
  valueType,
  setValueType,
}: {
  amount: number | undefined;
  setAmount: (value: number) => void;
  valueType: DiscountValueType;
  setValueType: (value: DiscountValueType) => void;
}) {
  return (
    <RedoTextInput
      inputTypeHint="number"
      label="Discount amount"
      placeholder="Add a discount amount"
      setValue={(value) => {
        setAmount(Number(value));
      }}
      trailingActions={
        <Flex>
          <RedoSingleSelectDropdownInput<DiscountValueType>
            fitToAnchor={false}
            hideBorder
            options={discountValueTypeItems}
            optionSelected={({ item }) => {
              setValueType(item.value);
            }}
            selectedItem={discountValueTypeItems.find(
              (o) => o.value === valueType,
            )}
            size="xs"
          />
        </Flex>
      }
      value={
        amount !== undefined
          ? amount % 1 === 0
            ? amount.toString()
            : amount.toFixed(2).replace(/\.?0+$/, "")
          : ""
      }
    />
  );
}
